<template>
  <div>
    <div @input="value.want_to_update=true">
      <div v-if="value.id > 0">
        <vx-card
          v-if="$can('review_campaigns') && value.acceptance_status !== $constants.AD_ACCEPTANCE_STATUSES.UNDER_REVIEW"
          class="mb-4 font-medium text-speakol-black-color"
          :noShadow="true">
          <AdminAdStatusCard
            :ad="value"
            @view-feedback="showRejectionForm = true"
          >
          </AdminAdStatusCard>
        </vx-card>

        <vx-card
          v-if="!$can('review_campaigns')"
          class="mb-4 font-medium text-speakol-black-color"
          :noShadow="true">
          <AdvertiserAdStatusCard
            :ad="value"
            @accept-recommendation="handleRecommendationsAcceptance"
          >
          </AdvertiserAdStatusCard>
        </vx-card>
      </div>

      <vx-card class="mb-10" :noShadow="true">
        <div class="ad-details-parent float-left flex">
          <h5 class="font-medium text-2xl">
            {{ $t('Ad Details') }}
          </h5>
          <speakol-tooltip class="ads-tooltip"
            :tooltipRedirect="'https://speakol.zendesk.com/hc/en-us/articles/360016704080-Ads-Customization-'"
            :tooltipAction="'Learn more here'"
            :tooltipText="'Customizing your ads; choose your content and visuals; preview your ads before they go live.'">
          </speakol-tooltip>
        </div>

        <div class="float-right preview-button-parent">
          <vs-button v-if="advertisingChannel.id !== constants.CAMPAIGN_ADVERTISING_CHANNELS_IDS.FACEBOOK" v-on:click="$gtag.event('Step5_PreviewAd')" id="create-campaign-s5-preview-button" @click="value.is_previewing = true" class="preview-button" color="primary" type="border">
            <img class="relative button-icon" src="@/assets/images/Shape.svg" />
            {{ $t('Preview Ad') }}
          </vs-button>

          <!-- Hold & Resume Buttons -->
          <vs-button id="edit-campaign-ad-hold-button" v-if="canHold" @click="showHoldModal = true" class="ml-3 hold-button" color="danger" type="border">
            <img class="relative button-icon" width="18" height="18" src="@/assets/images/pause.svg" />
            {{ $t('Hold') }}
          </vs-button>
          <vs-button id="edit-campaign-ad-resume-button" v-if="canResume" @click="changeAcceptanceStatus('Accepted')" class="ml-3 hold-button"
            color="primary" type="border">
            <img class="relative button-icon" width="18" height="18" src="@/assets/images/resume.svg" />
            {{ $t('Resume') }}
          </vs-button>

          <!-- Pause and Resume Button -->
          <vs-button v-if="canPause" @click="changeActivationStatus('Paused')" class="ml-3 hold-button" color="danger"
            type="border">
            <img class="relative button-icon" width="18" height="18" src="@/assets/images/pause.svg" />
            {{ $t('Pause') }}
          </vs-button>
          <vs-button v-if="canActivate" @click="changeActivationStatus('Active')" class="ml-3 hold-button"
            color="primary" type="border">
            <img class="relative button-icon" width="18" height="18" src="@/assets/images/resume.svg" />
            {{ $t('Activate') }}
          </vs-button>
        </div>

        <h5 class="ad-details-desc text-base font-normal text-gray-500 mt-10 mb-4">
          {{ $t('Fill in the below fields to customize your ad.') }}
        </h5>

        <div class="mobile-preview-button">
          <vs-button @click="value.is_previewing = true" class="w-full preview-button" color="primary" type="border">
            <img class="relative button-icon" src="@/assets/images/Shape.svg" />
            {{ $t('Preview Ad') }}
          </vs-button>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mt-8">
            <vs-input id="create-campaign-s5-title-input" :label="$t('Title')" v-model="value.content" :placeholder="$t('Title')" class="w-full"
                      :maxLength="maxTitleLength" :disabled="disableEditing" :name="`step5.adsets.${adsetIndex}.ads.${adIndex}.content`"
                      v-validate="`required|max:${maxTitleLength}`" :data-vv-as="$t('Title')"
                      :danger="$vErrors.has([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.content`)" />

            <span class="text-primary" v-if="type == 'Inline'">
              This input won’t be displayed to websites visitors
            </span>

            <span v-if="$vErrors.has([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.content`)"
              class="text-danger">
              {{ $vErrors.first([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.content`) }}
            </span>
          </div>

          <div v-if="showLandingPageURL" class="vx-col md:w-1/2 w-full mt-8">
            <vs-input id="create-campaign-s5-Landing-page-url-input" :label="urlLable" v-model="value.url" placeholder="https://www.speakol.com" class="w-full"
              :disabled="disableEditing" :name="`step5.adsets.${adsetIndex}.ads.${adIndex}.url`"
              v-validate="'required'" :data-vv-as="urlLable"
              :danger="$vErrors.has([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.url`)" />
            <span class="text-danger"
              v-if="$vErrors.has([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.url`)">
              {{ $vErrors.first([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.url`) }}
            </span>
          </div>

          <div class="vx-col md:w-1/2 w-full mt-8" v-if="enabledCTA">
            <label class="vs-input--label pl-0">{{$t('Call to action ( Optional )')}}</label>
            <v-select
              dir="ltr"
              id="create-campaign-cta"
              :name="`step5.adsets.${adsetIndex}.ads.${adIndex}.cta`"
              label="value"
              :data-vv-as="$t('call to action')"
              :options="ctaOptions"
              :disabled="advertisingChannel.id === constants.CAMPAIGN_ADVERTISING_CHANNELS_IDS.FACEBOOK && value.acceptance_status === 1"
              class="baisc-select mt-3 mb-3 "
              :placeholder="$t('Not Selected')"
              v-model="value.cta"
            />
          </div>
        </div>

        <div class="vx-row" v-if="value.has_phone">
          <div class="vx-col md:w-1/2 mt-8">
            <label class="vs-input--label pl-0">Direct to</label>
            <div class="vs-con-input pt-3">
              <vs-radio id="create-campaign-s5-whatsapp-radiobox" v-model="value.phone_type" class="mr-6" :vs-name="'phone_type-' + adsetIndex + '-' + adIndex"
                vs-value="whatsapp" :disabled="disableEditing">
                {{ $t("WhatsApp") }}
              </vs-radio>
              <vs-radio id="create-campaign-s5-phone-radiobox" v-model="value.phone_type" class="ml-6" :vs-name="'phone_type-' + adsetIndex + '-' + adIndex"
                vs-value="phone" :disabled="disableEditing">
                {{ $t("Phone") }}
              </vs-radio>
            </div>
          </div>

          <div class="vx-col md:w-1/2 mt-8">
            <label class="vs-input--label">{{ value.phone_type == 'whatsapp' ? $t('WhatsApp Number') : $t('Phone Number') }}</label>
            <div class="international-number">
              <vue-phone-number-input id="create-campaign-s5-phone-input" v-model="value.phone_number" class="w-full mt-3" v-on:update="phoneUpdated"
                no-validator-state :default-country-code="value.country_code"
                :data-vv-as="value.phone_type == 'whatsapp' ? $t('WhatsApp Number') : $t('Phone Number')" :translations="{
                  phoneNumberLabel: value.phone_type == 'whatsapp' ? $t('WhatsApp Number') : $t('Phone Number')
                }" :disabled="disableEditing"
                :danger="$vErrors.has([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.phone_number`)" />
            </div>

            <span v-if="$vErrors.has([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.phone_number`)"
              class="text-danger">
              {{ $vErrors.first([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.phone_number`) }}
            </span>
          </div>
        </div>

        <div v-if="value.has_video || value.is_story" class="vx-row">
          <div v-if="value.is_story" class="vx-col md:w-1/2 w-full mt-8">
            <label class="vs-input--label">Choose the type of Story</label>
            <div class="radio-buttons-parent vs-con-input">
              <vs-radio id="create-campaign-s5-image-radiobox" v-model="value.story_type" class="mr-6" :vs-name="'story_type-' + adsetIndex + '-' + adIndex"
                vs-value="image" :disabled="disableEditing">
                {{ $t("Image") }}
              </vs-radio>
              <vs-radio id="create-campaign-s5-video-radiobox" v-model="value.story_type" class="responsive-margin ml-6"
                :vs-name="'story_type-' + adsetIndex + '-' + adIndex" vs-value="video" :disabled="disableEditing">
                {{ $t("Video") }}
              </vs-radio>
            </div>
          </div>

          <div v-if="value.has_video" class="vx-col md:w-1/2 w-full mt-8">
            <label class="vs-input--label">Video Type</label>
            <div class="vs-con-input">
              <vs-radio id="create-campaign-s5-video-quick-upload-radiobox" v-model="value.upload_video" class="mr-6"
                :vs-name="'upload_video-' + adsetIndex + '-' + adIndex" :vs-value="true" @change="uploadVideoChanged"
                :disabled="disableEditing">
                {{ $t("Quick Upload") }}
              </vs-radio>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mt-8" v-if="value.upload_enabled">
            <Upload
              v-model="value.file"
              :type="value.upload_video ? 'video' : 'image'"
              :key="uploadImageKey"
              :accept="value.upload_video ? 'video/mp4' : 'image/x-png,image/jpeg'"
              :maxSize="value.upload_video ? ad_video_max_file_size : 0.3"
              :placeholder="imgPlaceholder"
              :height="imgHeight"
              :width="imgWidth"
              :validateOnDrop="handleValidateOnDrop"
              :disabled="disableEditing"
              :serverErrors="[$vErrors.first([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.file`)]" />
          </div>

          <div class="vx-col w-full mt-8" v-if="!value.upload_enabled">
            <vs-input v-model="value.file" placeholder="https://www.youtube.com" class="w-full"
              :disabled="disableEditing" :name="`step5.adsets.${adsetIndex}.ads.${adIndex}.file`"
              v-validate="'required'" :data-vv-as="'Video Link'"
              :danger="$vErrors.has([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.file`)" />

            <span class="text-danger"
              v-if="$vErrors.has([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.file`)">
              {{ $vErrors.first([errors, serverErrors], `step5.adsets.${adsetIndex}.ads.${adIndex}.file`) }}
            </span>
          </div>
        </div>

        <ImpressionTracker v-if="advertisingChannel.id !== constants.CAMPAIGN_ADVERTISING_CHANNELS_IDS.FACEBOOK" v-model="value.impressions_tracker" :adsetIndex="adsetIndex" :adIndex="adIndex"
          :serverErrors="serverErrors" />
      </vx-card>

      <!-- <DemographicsAnnotation v-model="value" @input="value.want_to_update=true" :adsetIndex="adsetIndex" :adIndex="adIndex" /> -->

      <vx-card class="mb-10" :noShadow="true" v-if="editing && $can('review_campaigns') && value.acceptance_status === null && !showRejectionForm">
        <div class="float-left">
          <p class="font-bold pt-3">
            Does this ad abide by all Speakol’s advertising policies ?
          </p>
        </div>

        <div class="reject-accept-mobile-version flex float-right">
          <vs-button class="rounded-full shadow-none mr-2" color="danger" type="filled" @click="showRejectionForm = true , stopScroll()">
            {{ $t('Reject') }}
          </vs-button>

          <vs-button class="shadow-none rounded-full" color="success" type="filled" @click="changeAcceptanceStatus('Accepted')">
            {{ $t('Accept') }}
          </vs-button>
        </div>
      </vx-card>

      <vs-popup v-if="$can('review_campaigns')" class="holamundo" title="On Hold" :active.sync="showHoldModal">
        <HoldForm @cancel-hold="showHoldModal = false" @acceptance-status-updated="acceptanceStatusUpdated"
          :ad="value" />
      </vs-popup>
    </div>

    <vs-popup v-if="$can('review_campaigns') && showRejectionForm" class="ad-recommendations text-left" :active.sync="showRejectionForm" :buttons-hidden="true">
      <RejectionForm
        :adId="value.id"
        @acceptance-status-updated="changeAcceptanceStatus('Rejected')"
        @cancel="showRejectionForm = false">
      </RejectionForm>
    </vs-popup>

    <SpeakolNotificationToaster
      :show="toaster.show"
      :message="toaster.message"
      :icon="toaster.icon"
      :closeButtonText="toaster.closeButtonText"
      @close="toaster.show=false">
    </SpeakolNotificationToaster>
  </div>
</template>

<script>
import SpeakolNotificationToaster from '@/components/SpeakolNotificationToaster'
import Upload from '@/views/campaigns/components/Upload.vue'
import HoldForm from '@/views/campaigns/components/steps/components/AdsetAds/components/Feedback/HoldForm.vue'
// import DemographicsAnnotation from '@/views/campaigns/components/steps/components/AdsetAds/components/DemographicsAnnotation.vue'
import ImpressionTracker from '@/views/campaigns/components/steps/components/AdsetAds/components/ImpressionTracker.vue'
import SpeakolTooltip from '@/components/speakol-template/SpeakolTooltip.vue'
import {cloneDeep} from 'lodash'
import english from '@/i18n/lang/en.json'
import arabic from '@/i18n/lang/ar.json'
import RejectionForm from '@/views/campaigns/components/steps/components/AdsetAds/components/Feedback/RejectionForm.vue'
import AdvertiserAdStatusCard from '@/views/campaigns/components/steps/components/AdsetAds/components/Feedback/AdvertiserAdStatusCard.vue'
import AdminAdStatusCard from '@/views/campaigns/components/steps/components/AdsetAds/components/Feedback/AdminAdStatusCard.vue'

export default {
  props: {
    value: {
      required: true,
      type: Object
    },
    adsetIndex: {
      required: true,
      type: Number
    },
    adIndex: {
      required: true,
      type: Number
    },
    serverErrors: {
      required: true
    },
    advertisingChannel: {
      type: Object,
      required: true
    },
    objective: {
      type: String,
      required: true
    },
    objectiveId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    editing: {
      type: Boolean,
      default: false,
      required: false
    },
    adset: {
      type: Object,
      required: true
    }
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    },
    'value.story_type' () {
      if (this.value.story_type === 'video') {
        this.enableVideo()
      }

      if (this.value.story_type === 'image') {
        this.disableVideo()
      }
    },
    objective () {
      this.changeComponentState(this.objective, this.type)
    },
    type () {
      this.changeComponentState(this.objective, this.type)
    }
  },
  components: {
    Upload,
    // DemographicsAnnotation,
    ImpressionTracker,
    HoldForm,
    SpeakolTooltip,
    SpeakolNotificationToaster,
    RejectionForm,
    AdvertiserAdStatusCard,
    AdminAdStatusCard
  },
  computed: {
    default () {
      return cloneDeep(this.$store.getters['campaign/defaultAdObject'])
    },
    urlLable () {
      if (this.objective === 'App Installs') {
        return this.$t('App URL')
      }
      return this.$t('Landing Page URL')
    },
    disableEditing () {
      if (this.editing && !this.advertisingChannel.supports_update_landing_page_url && this.value.acceptance_status) {
        return true
      }
      return this.editing && this.value.acceptance_status === 2 && !this.$can('review_campaigns')
    },
    canHold () {
      return this.$can('review_campaigns') && this.value.acceptance_status === 1 && this.editing
    },
    canResume () {
      return this.$can('review_campaigns') && this.value.acceptance_status === 2 && this.editing
    },
    canPause () {
      return this.value.acceptance_status === 1 && this.value.activation_status === 1 && this.editing
    },
    canActivate () {
      return this.value.acceptance_status === 1 && this.value.activation_status === 0 && this.editing
    },
    canReview () {
      const isFeedbackableStatus = [
        this.$constants.AD_ACCEPTANCE_STATUSES.REJECTED,
        this.$constants.AD_ACCEPTANCE_STATUSES.ON_HOLD
      ].includes(this.value.acceptance_status)

      return !this.$can('review_campaigns') && this.editing && isFeedbackableStatus && this.value.feedback
    },
    enabledCTA () {
      return this.$hasFeature('ad-cta') && (
        this.type == this.$constants.CAMPAIGN_TYPES_NAMES.RECOMMENDATIONS ||
        [
          this.$constants.CAMPAIGN_OBJECTIVES_IDS.FACEBOOK_OUTCOME_TRAFFIC,
          this.$constants.CAMPAIGN_OBJECTIVES_IDS.FACEBOOK_OUTCOME_CONVERSION_LEADS,
          this.$constants.CAMPAIGN_OBJECTIVES_IDS.FACEBOOK_OUTCOME_CONVERSION_SALES
        ].includes(this.objectiveId)
      )
    }
  },
  data () {
    return {
      ad_video_max_file_size: process.env.VUE_APP_AD_VIDEO_MAX_FILE_SIZE,
      is_created: false,
      showHoldModal: false,
      showLandingPageURL: true,
      ctaOptions: [],
      showRejectionForm: false,
      showRecommenitionPopup: false,
      toaster: {
        show: false,
        message: 'Feedback has been submitted.',
        icon: require('@/assets/images/success.svg'),
        closeButtonText: 'X'
      },
      uploadImageKey: Math.random(),
      constants : this.$constants,
      imgHeight: 360,
      imgWidth: 640,
      imgPlaceholder: {
        dimensions: 'Dimensions：640*360 px'
      },
      maxTitleLength: this.advertisingChannel.id === this.$constants.CAMPAIGN_ADVERTISING_CHANNELS_IDS.FACEBOOK ? 150 : 70
    }
  },
  created () {
    this.changeComponentState(this.objective, this.type)

    // update imgHeight and imgWidth based on the type of the ad
    if (this.type === this.$constants.CAMPAIGN_TYPES_NAMES.SINGLE_IMAGE) {
      this.imgWidth = 1080
      this.imgHeight = 1080
      this.imgPlaceholder.dimensions = 'Dimensions：1080*1080 px'
    }

    // Just to verify that functions in this component is running only when the component is created
    this.is_created = true
    this.setCTALocale()
  },
  methods: {
    setCTALocale () {
      const localeFile = this.adset.language === this.$constants.LANGUAGES.AR ? arabic : english

      this.ctaOptions = localeFile.ad_ctas

      if (this.objectiveId === this.$constants.CAMPAIGN_OBJECTIVES_IDS.FACEBOOK_OUTCOME_TRAFFIC) {
        this.ctaOptions = english.ad_ctas_facebook_traffic
      }

      if (this.objectiveId === this.$constants.CAMPAIGN_OBJECTIVES_IDS.FACEBOOK_OUTCOME_CONVERSION_LEADS) {
        this.ctaOptions = english.ad_ctas_facebook_conversions_leads
      }

      if (this.objectiveId === this.$constants.CAMPAIGN_OBJECTIVES_IDS.FACEBOOK_OUTCOME_CONVERSION_SALES) {
        this.ctaOptions = english.ad_ctas_facebook_conversions_sales
      }

      if (this.value.cta) {
        const localeCTA = this.ctaOptions.find(el => el.key === this.value.cta.key)

        this.value.cta = localeCTA ? localeCTA : null
      }
    },

    stopScroll () {
      document.documentElement.style.overflow = 'hidden'
    },

    handleValidateOnDrop (file) {
      return this.value.upload_video ? /\.(mp4)$/.test(file.name) : /\.(jpeg|png|jpg)$/.test(file.name)
    },
    acceptanceStatusUpdated ({
      acceptance_status,
      camapign_aggregated_status
    }) {
      this.value.acceptance_status = acceptance_status

      if (this.value.acceptance_status === this.$constants.AD_ACCEPTANCE_STATUSES.ACCEPTED) {
        this.toaster.message = 'The ad is accepted.'
      } else if (this.value.acceptance_status === this.$constants.AD_ACCEPTANCE_STATUSES.ON_HOLD) {
        this.toaster.message = 'Feedback has been submitted.'
      }

      this.toaster.show = true

      this.showRejectionForm = false

      setTimeout(() => {
        this.toaster.show = false
      }, 3000)

      this.$root.$emit('displayable-status-updated', camapign_aggregated_status)
    },
    async changeAcceptanceStatus (status) {
      const response = await window.axios.post(`/campaigns/${this.$route.params.id}/update-ad-acceptance-status`, {
        hideLoader: true,
        status,
        ad_id: this.value.id,
        _method: 'PATCH'
      })

      this.acceptanceStatusUpdated(response.data.payload)
    },
    async changeActivationStatus (status) {
      const response = await window.axios.post(`/campaigns/${this.$route.params.id}/update-ad-activation-status`, {
        status,
        ad_id: this.value.id,
        _method: 'PATCH'
      })

      this.value.activation_status = response.data.payload.activation_status
    },
    changeComponentState (objective, type) {
      if (type === 'Video') {
        this.enableVideo()
      } else {
        this.disableVideo()
        this.disableUpload()
      }

      if (type === 'Stories') {
        this.enableStory()
      } else {
        this.disableStory()
      }

      if (objective === 'Whatsapp - Phone') {
        this.enablePhone()
      } else {
        this.disablePhone()
      }

      this.showLandingPageURL = this.objective !== this.$constants.CAMPAIGN_OBJECTIVES_NAMES.LEAD_FORM && !this.value.has_phone
    },
    enablePhone () {
      this.value.has_phone = true
    },
    disablePhone () {
      this.value.has_phone = false
      this.value.phone_type = 'whatsapp'
      this.value.phone_number = null
    },
    enableVideo () {
      this.value.has_video = true
      this.value.upload_video = true

      // to enable video we need to enable the upload also
      this.enableUpload()
    },
    disableVideo () {
      if (this.is_created) {
        this.value.has_video = this.default.has_video
        this.value.upload_video = this.default.upload_video
      }

      // to enable video we need to enable the upload also
      this.enableUpload()
    },
    enableUpload () {
      if (this.is_created) {
        this.value.file = null
      }

      this.value.upload_enabled = true
    },
    disableUpload () {
      if (this.is_created) {
        this.value.file = null
      }

      this.value.upload_enabled = false
    },
    enableStory () {
      this.value.is_story = true

      if (this.is_created || this.value.story_type === null) {
        this.value.story_type = 'image'
      }

      this.enableUpload()
    },
    disableStory () {
      this.value.is_story = this.default.is_story
      this.value.story_type = this.default.story_type

      // reset upload state
      this.enableUpload()
    },
    uploadVideoChanged () {
      if (this.value.upload_video) {
        this.enableUpload()
      } else {
        this.disableUpload()
      }
    },
    phoneUpdated (event) {
      this.value.country_code = event.countryCode
      this.value.phone_number = event.e164
      this.value.url = event.e164
    },
    handleRecommendationsAcceptance (event) {
      this.value.file = JSON.parse(event.frontend_meta).file
      this.value.content = event.title
      this.value.acceptance_status = event.acceptance_status

      // re-render image component to display the new recommended image
      this.uploadImageKey = Math.random()

      this.toaster.show = true
      this.toaster.message = this.$t('create_campaign.step5.ad_status.adv_popups.rejection.toaster')

      setTimeout(() => {
        this.toaster.show = false
      }, 3000)
    }
  }
}

</script>

<style lang="scss">
  .ad-details-parent {
    .customize-tooltip-with-action {
      right: -100px !important;
    }

    .triangle-left {
      right: 100px !important;
    }
  }

  .ads-tooltip {
    position: relative;
    top: -2px;
  }

  .button-icon {
    left: -8px !important;
    top: 4px;
  }

  .preview-button {
    border-radius: 4px !important;
    padding: 6px 20px 8px 30px !important;
  }

  .hold-button {
    border-radius: 4px !important;
    padding: 6px 20px 8px 30px !important;
  }

  .mobile-preview-button {
    display: none;
  }

  @media (max-width: 576px) {
    .tables-rows-vertical-align {
      vertical-align: initial;
    }

    .vs__dropdown-menu {
      position: inherit !important;
    }

    .preview-button {
      padding: 6px 10px 8px 15px !important;
    }

    .ad-details-desc {
      margin-top: 40px !important;
    }

    .mobile-preview-button {
      display: block;
    }

    .back-to-ad-button {
      display: none;
    }

    .preview-button-parent {
      display: none;
    }

    .radio-buttons-parent {
      display: grid;

      .responsive-margin {
        margin-left: 0 !important;
        margin-top: 10px;
      }
    }

    .impression-tracker-table {
      width: max-content !important;
      position: relative;
    }

    .table-parent {
      overflow-x: auto;
    }

    .reject-accept-mobile-version {
      margin-top: 20px;
    }
  }

  .input-tel__input:hover {
    border-color: rgba(0, 0, 0, 0.15) !important;
  }

  .input-tel__input:focus,
  .country-selector__input:focus {
    box-shadow: none !important;
    border-color: rgba(0, 0, 0, 0.15) !important;
  }

  .international-number {
    .country-selector__label {
      display: none;
    }

    .country-selector.has-value .country-selector__input {
      padding-top: 0 !important;
      padding-right: 10px !important;
    }

    .country-selector__country-flag {
      top: 12px;
    }
  }

</style>
